import { OutOfOfficeReturnCard } from "@/components/out-of-office/out-of-office-return-banner"

export function OooReturnPreviewPage() {
	return (
		<div className="flex h-full gap-10 bg-gray-50 p-10 dark:bg-gray-950">
			<div className="flex w-[240px] flex-col justify-end bg-gray-50 pb-11 dark:bg-gray-950">
				<OutOfOfficeReturnCard
					coverFirstName="Raphael"
					threadCount={4}
					onTakeBack={() => undefined}
					onLeave={() => undefined}
				/>
			</div>
		</div>
	)
}
